import { render, staticRenderFns } from "./BracketsGeneratingLoader.vue?vue&type=template&id=505624e6"
import script from "./BracketsGeneratingLoader.vue?vue&type=script&lang=js"
export * from "./BracketsGeneratingLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports